import { __extends } from "tslib";
import { SdkMessageTypes } from '../constants';
import { FrameContexts } from '../messages.interface';
import { BaseMessageHandler } from './base-message-handler';
import { callServiceAndFormulateAppMessageResult, onStatusError } from './messageHandlingUtils';
import { callServiceAndFormulateLogMessageResult } from './messageHandlingUtils';
/**
 * Responsible for Page.config module related message requests.
 */
var PageConfigMessageHandler = /** @class */ (function (_super) {
    __extends(PageConfigMessageHandler, _super);
    function PageConfigMessageHandler(appSdkHost, configService, telemetryService) {
        var _this = _super.call(this, appSdkHost, telemetryService) || this;
        _this.appSdkHost = appSdkHost;
        _this.configService = configService;
        _this.telemetryService = telemetryService;
        return _this;
    }
    PageConfigMessageHandler.prototype.initHandlers = function () {
        var _this = this;
        if (this.appSdkHost.getFrameContext() === FrameContexts.settings && !this.configService) {
            throw new Error('Config Service needs to be implemented when in settings frame context');
        }
        this.registerHandler(SdkMessageTypes.pages.config.setConfig, function (_, params) { return callServiceAndFormulateAppMessageResult(_this.configService.setConfig, params); }, {
            errorCallback: function (error, scenario) { return onStatusError(SdkMessageTypes.pages.config.setConfig, error, scenario); },
        });
        this.registerHandler(SdkMessageTypes.pages.config.setValidityState, function (_, params) {
            return callServiceAndFormulateLogMessageResult(_this.configService.setValidityState, params);
        });
        this.registerHandler(SdkMessageTypes.pages.config.save.success, function (_) {
            return callServiceAndFormulateLogMessageResult(_this.configService.onSaveSuccess);
        });
        this.registerHandler(SdkMessageTypes.pages.config.save.failure, function (_, params) {
            return callServiceAndFormulateLogMessageResult(_this.configService.onSaveFailure, params);
        });
        this.registerHandler(SdkMessageTypes.pages.config.remove.success, function (_) {
            return callServiceAndFormulateLogMessageResult(_this.configService.onRemoveSuccess);
        });
        this.registerHandler(SdkMessageTypes.pages.config.remove.failure, function (_, params) {
            return callServiceAndFormulateLogMessageResult(_this.configService.onRemoveFailure, params);
        });
    };
    PageConfigMessageHandler.prototype.validateDependencies = function () {
        if (!this.configService) {
            throw 'No configService provided';
        }
    };
    return PageConfigMessageHandler;
}(BaseMessageHandler));
export { PageConfigMessageHandler };
//# sourceMappingURL=page-config-message-handler.js.map